module.exports = __webpack_public_path__ + "static/img/gms.ecfb9836.png";